"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Gradient = function Gradient(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-gradient"
  }, children);
};

Gradient.propTypes = {
  /**
   * children for content inside
   */
  children: _propTypes["default"].node
};
Gradient.defaultProps = {
  children: []
};
var _default = Gradient;
exports["default"] = _default;